export const host = "http://localhost:3000";
export const apiHost = "http://localhost:3001";
